import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=ab740780&lang=pug&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab740780')) {
      api.createRecord('ab740780', component.options)
    } else {
      api.reload('ab740780', component.options)
    }
    module.hot.accept("./CampaignDetails.vue?vue&type=template&id=ab740780&lang=pug&", function () {
      api.rerender('ab740780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/campaigns/CampaignDetails/CampaignDetails.vue"
export default component.exports